import { useAppSelector } from '~/hooks/useAppSelector';
import { ActiveShiftTabEnum } from '../enums';
import { useMemo } from 'react';

/**
 * @param bidFeedbackCount - CS-5 pending-BID-feedback count (GOTU-5643).
 * Sourced from React Query (`usePendingBidFeedback`), not Redux, so it's
 * passed in by the caller rather than read here — keeps this hook's own
 * tests free of a `QueryClientProvider` wrapper. Defaults to 0 so existing
 * callers (and the v2-flag-off path, where the query never fires) are
 * unaffected.
 */
export const useActiveShifts = (bidFeedbackCount = 0) => {
  const todayShiftsCount = useAppSelector((state) => state.job.dashboardInfo?.todayShift || 0);
  const reviewShiftsCount = useAppSelector(
    (state) => state.job.dashboardInfo?.pendingReviewJobCount || 0,
  );

  const activeTab = useMemo(() => {
    if (todayShiftsCount > 0) {
      return ActiveShiftTabEnum.Today;
    }

    if (reviewShiftsCount > 0) {
      return ActiveShiftTabEnum.PendingReview;
    }

    if (bidFeedbackCount > 0) {
      return ActiveShiftTabEnum.BidFeedback;
    }

    return ActiveShiftTabEnum.Today;
  }, [reviewShiftsCount, todayShiftsCount, bidFeedbackCount]);

  return {
    activeTab,
    counters: {
      todays: todayShiftsCount,
      reviews: reviewShiftsCount,
      bidFeedback: bidFeedbackCount,
    },
  };
};
